class AbsenceUtils {
  constructor(Authentication, $uibModal, sdk) {
    'ngInject';

    const { NO_SHOW_TYPE, SICK_CALLOUT_TYPE } = sdk('constants');
    Object.assign(this, { Authentication, $uibModal, NO_SHOW_TYPE, SICK_CALLOUT_TYPE });

    this.isAbsenceEvent = sdk('helpers/isAbsenceEvent');
  }

  canMarkAsNoShow(event, skipPremiumCheck = false) {
    const canAccessFeature = skipPremiumCheck || this.Authentication.isOrgFeatureEnabled('noShow');
    return Boolean(canAccessFeature && this.canMarkAsAbsence(event));
  }

  canMarkAsSickCallout(event, skipPremiumCheck = false) {
    const canAccessFeature =
      skipPremiumCheck || this.Authentication.isOrgFeatureEnabled('sickCallout');
    return Boolean(canAccessFeature && this.canMarkAsAbsence(event));
  }

  canMarkAsAbsence(event) {
    const canActOnLocation = this.Authentication.user.canActOnLocation(event.location);
    return Boolean(
      canActOnLocation && this.Authentication.isPrefab && !this.isAbsenceEvent(event) && event.user
    );
  }

  markAsNoShow(event) {
    return this._markAbsence(event, 'noShow', this.NO_SHOW_TYPE);
  }

  markAsSickCallout(event) {
    return this._markAbsence(event, 'sickCallout', this.SICK_CALLOUT_TYPE);
  }

  _markAbsence(event, featureGuardName, absenceType) {
    if (!this.Authentication.isOrgFeatureEnabled(featureGuardName)) {
      return;
    }

    return this.addAbsenceEventModal(event, absenceType);
  }

  addAbsenceEventModal(eventData, absenceEventType = this.NO_SHOW_TYPE, { noAnimation } = {}) {
    const modalInstance = this.$uibModal.open({
      name: `NoShowModalCtrl-${absenceEventType}`,
      template: __TEST__
        ? 'TEMPLATE'
        : '<add-absence-event modal="ctrl.modal" data="ctrl.data" type="{{ctrl.type}}"></add-absence-event>',
      controller: function editNoShowCtrl($uibModalInstance, type, data) {
        'ngInject';

        this.modal = $uibModalInstance;
        this.type = type;
        this.data = data;
      },
      controllerAs: 'ctrl',
      size: '620',
      animation: !noAnimation,
      backdrop: 'static',
      resolve: {
        data() {
          return eventData;
        },
        type() {
          return absenceEventType;
        },
      },
    });

    return modalInstance.result;
  }

  viewAbsenceModal(eventData) {
    const html = '<absence-view modal="ctrl.modal" event="ctrl.event"></absence-view>';
    this.$uibModal
      .open({
        name: 'ViewAbsenceEvent',
        template: __TEST__ ? 'TEMPLATE' : html,
        controller: function viewAbsenceCtrl($uibModalInstance, event) {
          'ngInject';

          this.modal = $uibModalInstance;
          this.event = event;
        },
        controllerAs: 'ctrl',
        size: '620',
        resolve: {
          event() {
            return eventData;
          },
        },
      })
      .result.ignoreCancel();
  }
}

export default AbsenceUtils;
